module.exports = __webpack_public_path__ + "ap.no1.02883ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ap.no1.jpg
// module id = lkGN
// module chunks = 0